export enum ResearchAreaActionType {
    CREATE_RESEARCH_AREA = 'CREATE_RESEARCH_AREA',
    UPDATE_RESEARCH_AREA = 'UPDATE_RESEARCH_AREA',
    GET_ALL_RESEARCH_AREAS = 'GET_ALL_RESEARCH_AREAS',
    GET_RESEARCH_AREAS_BY_USER_INTAKES = 'GET_RESEARCH_AREAS_BY_USER_INTAKES',
    DELETE_RESEARCH_AREA = 'DELETE_RESEARCH_AREA',
}
